export const normalizeIntegerInput = (value) => {
  if (value === "" || value === null || value === undefined) return "";

  const str = String(value);
  if (str === "0") return "0";

  const normalized = str.replace(/^0+(?=\d)/, "");
  return normalized === "" ? "0" : normalized;
};

export const normalizeDecimalInput = (value) => {
  if (value === "" || value === null || value === undefined) return "";

  const str = String(value);

  if (str.includes(".")) {
    const dotIndex = str.indexOf(".");
    const intPart = str.slice(0, dotIndex);
    const decPart = str.slice(dotIndex + 1);
    let normalizedInt = intPart.replace(/^0+(?=\d)/, "");

    if (normalizedInt === "") {
      normalizedInt = "0";
    }

    return `${normalizedInt}.${decPart}`;
  }

  if (str === "0") return "0";

  const normalized = str.replace(/^0+(?=\d)/, "");
  return normalized === "" ? "0" : normalized;
};
